import React from 'react'

export default function RouteNotFound () {

  return (
    <h1>404 Page</h1>
  )
}
